import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import loaderimage from "../../images/giphy.gif";
import NewconfirmationModal from "../shared/NewconfirmationModal";
import AllFailureModal from "../shared/AllFailureModal";
import ConfirmationModal from "../shared/ConfirmationModal";

const JobList = () => {
  const [Jobs, setJobs] = useState([]);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(null);
  const [modalMessage, setModalMessage] = useState("");
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [actionType, setActionType] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");
  const [isConfirmModal, setIsConfirmModal] = useState(false);
  const [showModal, setShowModal] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalJobs, setTotalJobs] = useState(0);
    const [pageSize, setPageSize] = useState(50);

  const token = localStorage.getItem("jwttoken");
      const headers = {
        headers: {
          "x-access-token": token,
        },
      };
  
      const handleAction = async () => {
        if (!selectedJobId) return;
        const userRole = localStorage.getItem("userType");
        if (actionType === "Activate" && userRole !== "admin") {
          setFailureMessage("Only Admins can activate jobs.");
          setShowFailureModal(true);
          setShowModal(false);
          return;
        }
    
        try {
          let url = "";
          if (actionType === "Delete") {
            url = `${process.env.REACT_APP_API_URL}jobs/deletejob/${selectedJobId}`;
            await axios.put(url,{}, headers);
            setSuccessMessage("Job deleted successfully.");
          } else if (actionType === "Activate") {
            url = `${process.env.REACT_APP_API_URL}jobs/activatejob/${selectedJobId}`;
            await axios.put(url,{}, headers);
            setSuccessMessage("Job activated successfully.");
          } else if (actionType === "Deactivate") {
            url = `${process.env.REACT_APP_API_URL}jobs/deactivatejob/${selectedJobId}`;
            await axios.put(url,{}, headers);
            setSuccessMessage("Job deactivated successfully.");
          }
          callJobsListAPI(currentPage);
          setShowSuccessModal(true);
        } catch (error) {
          console.error(`Error performing ${actionType} action:`, error);
          setFailureMessage(`Failed to ${actionType.toLowerCase()} job.`);
          setShowFailureModal(true);
        } finally {
          setShowModal(false);
          setSelectedJobId(null);
        }
      };
      
      const callJobsListAPI = async (page = 1) => {
        try {
          setLoader(true);
          setError(null);
      
          const url = `${process.env.REACT_APP_API_URL}jobs/get-all-jobs?page=${page}&limit=${pageSize}`;
          const response = await axios.get(url,headers);
          const jobData = response.data.jobs || [];
          const total = response.data.total || 0;
          setJobs(jobData);
          setFilteredJobs(jobData);
          setTotalJobs(total);
          setTotalPages(Math.ceil(total / pageSize));
          setCurrentPage(page);
        } catch (error) {
          console.error("Error fetching job list:", error);
          setError("Oops! Something went wrong. Please try again later.");
        } finally {
          setLoader(false);
        }
      };
      

  useEffect(() => {
    callJobsListAPI(1);
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
  };

  useEffect(() => {
      const debounceTimeout = setTimeout(() => {
        if (searchTerm === "") {
          setFilteredJobs(Jobs);
        } else {
          const filtered = Jobs.filter(
            (job) =>
              job?.job_name?.toLowerCase().includes(searchTerm) ||
              job?.company_name?.toLowerCase().includes(searchTerm)
          );
          setFilteredJobs(filtered);
        }
      }, 300);
      return () => clearTimeout(debounceTimeout);
    }, [searchTerm, Jobs]);
  
  const triggerActionModal = (action, jobId) => {
    setSelectedJobId(jobId);
    setActionType(action);
    setIsConfirmModal(true);
    if (action === "Delete") {
      setModalMessage("Are you sure you want to delete this job?");
    } else if (action === "Activate") {
      setModalMessage("Are you sure you want to activate this job?");
    } else if (action === "Deactivate") {
      setModalMessage("Are you sure you want to deactivate this job?");
    }
    setShowModal(true);
  };
  
  const handlePageChange = (page) => {
    callJobsListAPI(page);
  };

  const startEntry = (currentPage - 1) * 100 + 1;
  const endEntry = Math.min(currentPage * 100, totalJobs);
  
  return (
    <div className="">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-black fw-bold">Job Management</h2>
        <div className="d-flex gap-2 align-items-center" style={{width:"460px"}}>
            <span className="fw-bold text-secondary text-nowrap">{totalJobs} results</span>
            <input
              type="text"
              className="form-control"
              placeholder="Search by Job or Company Name"
              value={searchTerm}
              onChange={handleSearch}
            />
          <Link to="/jobadd" className="btn bg-info">+ Add Job</Link>
        </div>
        
      </div>
      <div className="card shadow-sm border-0 rounded">
        <div className="card-header bg-info border-bottom py-3">
          <h5 className="mb-0 text-white">Job List</h5>
        </div>
        <div className="card-body p-0">
            <div className="table-responsive sticky-table-container" style={{ maxHeight: "500px", overflowY: "auto" }}>
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light position-sticky top-0" >
                    <tr>
                      <th>SR. No.</th>
                      <th>JobID</th>
                      <th>Job Name</th>
                      <th>Company Name</th>
                      <th>HR Name</th>
                      <th>Post Date</th>
                      <th>Job Status</th>
                      <th className="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                {loader ? (
                <tr>
                   <td colSpan="8" className="text-center py-2">
                     <img src={loaderimage} alt="Loading..." height="40" />
                  </td>
                </tr>
               ) : error ? (
                 <tr>
                  <td colSpan="8" className="text-center text-danger fw-bold py-3">
                     <div className="alert alert-danger text-center m-3" role="alert">
                       {error}
                     </div>
                   </td>
                 </tr>
               ) : filteredJobs.filter(job => job.job_status !== 0).length > 0 ? (
                filteredJobs.filter(job => job.job_status !== 0).map((item, index) => (
                    <tr key={index + 1} className="border-bottom">
                    <td>{index + 1}</td>
                    <td>{item.job_id}</td>
                     <td>{item.job_name}</td>
                    <td>{item.company_name}</td>
                    <td>{item.hr_name}</td>
                    <td>{item?.post_date?.split("T")[0]}</td>
                    <td className="text-center">
                    <span className={`me-2 rounded-circle d-inline-block ${item.job_status === 1 ? "bg-success" : "bg-danger"}`} 
                            style={{
                              width: "20px",
                              height: "20px",
                            }}>
                        </span>
                    </td>
                    <td className="text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <button
                            className={`btn btn-sm w-100 ${item.job_status === 1 ? "btn-outline-danger" : "btn-outline-success"}`}
                            onClick={() => triggerActionModal(item.job_status === 1 ? "Deactivate" : "Activate", item.job_id)}
                          >
                            {item.job_status === 1 ? "Deactivate" : "Activate"}
                          </button>
                          <Link to={`/job-detailed-description/${item.job_id}`} className="btn btn-sm btn-outline-warning">View</Link>
                          <Link to={`/jobupdate/${item.job_id}`} className="btn btn-sm btn-outline-warning">Edit</Link>
                          <button className="btn btn-sm btn-outline-secondary" onClick={() => triggerActionModal("Delete", item.job_id)}>
                            Delete
                          </button>
                        </div>
                      </td>
                                     
                                   </tr>
                    
                   ))
                  ) : (
                                    <tr>
                                       <td colSpan="8" className="text-center text-muted fw-bold">
                                         <div className="alert alert-secondary text-center m-3" role="alert">
                                           No Jobs Available
                                         </div>
                                       </td>
                                     </tr>
                                   )}
                                 </tbody>
              </table>
            </div>
        {/* Pagination */}
              <div className="position-sticky bottom-0 bg-white py-2 border-top">
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-muted ps-3">
                    Showing {startEntry}-{endEntry} of {totalJobs} entries
                  </div>
                  <nav>
                    <ul className="pagination mb-0 pe-3">
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button 
                          className="page-link" 
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                      </li>
                      {[...Array(totalPages)].map((_, index) => (
                        <li 
                          key={index} 
                          className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                        >
                          <button 
                            className="page-link" 
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button 
                          className="page-link" 
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
        </div>
      </div>
      
      <ConfirmationModal 
        show={showModal} 
        modalMessage={modalMessage} 
        onHide={() => setShowModal(false)} 
        confirmation={isConfirmModal ? handleAction : null} 
        operationType={actionType} 
      />

      <NewconfirmationModal 
        show={showSuccessModal} 
        onHide={() => setShowSuccessModal(false)} 
        modalMessage={successMessage} 
        operationType="OK" 
        timeoutDuration={3000} 
      />

      <AllFailureModal 
        show={showFailureModal} 
        onHide={() => setShowFailureModal(false)} 
        modalMessage={failureMessage} 
        operationType="OK" 
        timeoutDuration={3000} 
      />

    </div>
  );
};

export default JobList;
